import { ServerConnection } from "@/context/server"
import type { SessionTab } from "@/context/tabs"
import { getSessionContextByRemote } from "./api"
import { CoworkChatUnavailableError, openCoworkChat } from "./open-chat"

export async function reopenCoworkChat(
  tab: SessionTab,
  scope: { companyID: string; projectID: string },
  deps: Parameters<typeof openCoworkChat>[1],
) {
  if (deps.isCurrent?.() === false) return
  if (!scope.companyID || !scope.projectID) throw new CoworkChatUnavailableError()
  const context = await getSessionContextByRemote(tab.sessionId, scope.companyID)
  if (deps.isCurrent?.() === false) return
  if (!context || context.company_id !== scope.companyID || context.project_id !== scope.projectID ||
      context.remote_opencode_session_id !== tab.sessionId || !context.session_id) {
    throw new CoworkChatUnavailableError()
  }
  // The Accounting API must authorize the existing conversation before runtime
  // discovery. A retained runtime ID alone cannot revive a deleted/private chat.
  return openCoworkChat({
    companyID: context.company_id, projectID: context.project_id,
    periodID: context.period_id ?? context.workflow_id, sessionID: context.session_id,
    remoteSessionID: context.remote_opencode_session_id, title: context.title,
  }, {
    ...deps,
    beforeOpen: (reopened) => {
      // openCoworkChat has just refreshed this connection from the authenticated
      // API. The saved URL on the old tab is never used for network requests.
      const connection = deps.server.list.find((item) => ServerConnection.key(item) === reopened.server)
      if (!connection || connection.type !== "http") throw new CoworkChatUnavailableError()
      deps.server.setManagedRuntime(connection)
      deps.beforeOpen?.(reopened)
    },
  })
}
